module.exports = "## Message\n\n### 使用说明\n\n> 待完善"


//////////////////
// WEBPACK FOOTER
// ../~/.0.5.1@raw-loader!./docs/components/Message.md
// module id = 402
// module chunks = 1 4